import { Record } from "./fable_modules/fable-library-js.4.17.0/Types.js";
import { option_type, obj_type, array_type, int32_type, record_type, float64_type, string_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { comparePrimitives, int32ToString, uncurry2, createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { singleton as singleton_1, cons, empty as empty_1, ofArray } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { empty, append, singleton, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { Bar, Cell, ResponsiveContainer, ComposedChart, Legend, LineChart, ReferenceLine, Line, Tooltip, YAxis, XAxis } from "recharts";
import { Format_quoteToString, Time_utcDateToLocalDate, Time_utcDateToLocalDayAndMonth } from "./Components/Utils.js";
import { format } from "./fable_modules/fable-library-js.4.17.0/String.js";
import { useReact_useEffectOnce_3A5B6456, useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { value as value_47, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.17.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { DataServerBaseUrl } from "./Components/Constants.js";
import { fromString } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { LoadingIndicator_skeleton, Checkbox_checkbox, Alert_snackError } from "./Components/Components.js";
import { mapIndexed, sortBy, map as map_1, tryLast } from "./fable_modules/fable-library-js.4.17.0/Array.js";
import { DefaultBorder, Dimensions_TextSmall } from "./Components/Design.js";
import { StockRating__ToTextColorCode, StockRating, StockRating__ToColorCode } from "./Shared/Shared.js";
import { empty as empty_2, toArray, FSharpMap__TryFind, ofArray as ofArray_1 } from "./fable_modules/fable-library-js.4.17.0/Map.js";
import { AssetBanner } from "./Components/Ads.js";

class AssetRSI extends Record {
    constructor(Date$, RSI, Close) {
        super();
        this.Date = Date$;
        this.RSI = RSI;
        this.Close = Close;
    }
}

function AssetRSI_$reflection() {
    return record_type("AssetTA.AssetRSI", [], AssetRSI, () => [["Date", string_type], ["RSI", float64_type], ["Close", float64_type]]);
}

export class AssetMA extends Record {
    constructor(Date$, Quote, Value, Frame) {
        super();
        this.Date = Date$;
        this.Quote = Quote;
        this.Value = Value;
        this.Frame = (Frame | 0);
    }
}

export function AssetMA_$reflection() {
    return record_type("AssetTA.AssetMA", [], AssetMA, () => [["Date", string_type], ["Quote", float64_type], ["Value", float64_type], ["Frame", int32_type]]);
}

function taHolder(children) {
    return createElement("div", {
        style: {
            backgroundColor: "#FFFFFF",
            borderRadius: 5,
            border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
            padding: 2 + "vw",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function taGraphHolder(children) {
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
            gap: 10 + "px ",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function taTitle(title) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }], (elems = [createElement("h2", {
        style: {
            fontSize: 2 + "rem",
            fontWeight: 500,
            margin: 0,
        },
        children: title,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function description(txt) {
    return createElement("p", {
        style: {
            margin: 0,
        },
        children: txt,
    });
}

function rsiChart(data, showReferenceLines, showClose) {
    const props_17 = [["minWidth", 250], ["minHeight", 210], ["children", toList(delay(() => {
        let props_16, x_30, props_9, x_3;
        return !showClose ? singleton((props_16 = [["style", ofArray([["width", 450], ["height", 300]])], ["data", data], (x_30 = [0, 0, 0, 0], ["margin", {
            bottom: x_30[2],
            left: x_30[3],
            right: x_30[1],
            top: x_30[0],
        }]), ["children", toList(delay(() => append(singleton(Interop_reactApi_1.createElement(XAxis, {
            dataKey: "Date",
            tickFormatter: (tick_3) => (`${Time_utcDateToLocalDayAndMonth(tick_3)}`),
        })), delay(() => {
            let props_11;
            return append(singleton((props_11 = [["orientation", "right"], ["tickFormatter", (tick_4) => (`${~~tick_4}`)], ["domain", [0, 100]]], Interop_reactApi_1.createElement(YAxis, createObj(props_11)))), delay(() => append(singleton(Interop_reactApi_1.createElement(Tooltip, {
                formatter: (v_1) => ((_arg_2) => ((_arg_3) => format('{0:' + "0.00" + '}', v_1))),
            })), delay(() => append(singleton(Interop_reactApi_1.createElement(Line, {
                dataKey: "RSI",
                stroke: "#5F5566",
                strokeWidth: 3,
                dot: false,
            })), delay(() => (showReferenceLines ? append(singleton(Interop_reactApi_1.createElement(ReferenceLine, {
                y: 70,
                label: "Overkjøpt",
                strokeWidth: 2,
            })), delay(() => singleton(Interop_reactApi_1.createElement(ReferenceLine, {
                y: 30,
                label: "Oversolgt",
                strokeWidth: 2,
            })))) : empty())))))));
        }))))]], Interop_reactApi_1.createElement(LineChart, createObj(props_16)))) : singleton((props_9 = [["width", 450], ["height", 300], ["data", data], (x_3 = [0, 0, 0, 0], ["margin", {
            bottom: x_3[2],
            left: x_3[3],
            right: x_3[1],
            top: x_3[0],
        }]), ["children", toList(delay(() => append(singleton(Interop_reactApi_1.createElement(XAxis, {
            dataKey: "Date",
            tickFormatter: (tick) => (`${Time_utcDateToLocalDayAndMonth(tick)}`),
        })), delay(() => {
            let props_1;
            return append(singleton((props_1 = [["yAxisId", "left"], ["tickFormatter", (tick_1) => {
                if (tick_1 >= 1000000000) {
                    const bn = tick_1 / 1000000000;
                    return `${format('{0:' + "0.0" + '}', bn)} mrd`;
                }
                else if (tick_1 >= 1000000) {
                    const mill = tick_1 / 1000000;
                    return `${format('{0:' + "0.0" + '}', mill)}m`;
                }
                else if (tick_1 >= 1000) {
                    const k = tick_1 / 1000;
                    return `${format('{0:' + "0.0" + '}', k)}k`;
                }
                else {
                    return `${tick_1}`;
                }
            }], ["domain", ["auto", "auto"]]], Interop_reactApi_1.createElement(YAxis, createObj(props_1)))), delay(() => {
                let props_2;
                return append(singleton((props_2 = [["yAxisId", "right"], ["orientation", "right"], ["tickFormatter", (tick_2) => (`${~~tick_2}`)], ["domain", ["auto", "auto"]]], Interop_reactApi_1.createElement(YAxis, createObj(props_2)))), delay(() => append(singleton(Interop_reactApi_1.createElement(Tooltip, {
                    formatter: (v) => ((_arg) => ((_arg_1) => format('{0:' + "0.00" + '}', v))),
                })), delay(() => append(showReferenceLines ? append(singleton(Interop_reactApi_1.createElement(ReferenceLine, {
                    y: 70,
                    label: "Overkjøpt",
                    yAxisId: "right",
                    strokeWidth: 2,
                })), delay(() => singleton(Interop_reactApi_1.createElement(ReferenceLine, {
                    y: 30,
                    label: "Oversolgt",
                    yAxisId: "right",
                    strokeWidth: 2,
                })))) : empty(), delay(() => append(singleton(Interop_reactApi_1.createElement(Legend, {})), delay(() => append(singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "Close",
                    stroke: "var(--text-dim)",
                    strokeWidth: 3,
                    dot: false,
                    yAxisId: "left",
                })), delay(() => singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "RSI",
                    stroke: "#5F5566",
                    strokeWidth: 3,
                    dot: false,
                    yAxisId: "right",
                }))))))))))));
            }));
        }))))]], Interop_reactApi_1.createElement(ComposedChart, createObj(props_9))));
    }))]];
    return Interop_reactApi_1.createElement(ResponsiveContainer, createObj(props_17));
}

export function RelativeStrengthIndex(relativeStrengthIndexInputProps) {
    const ticker = relativeStrengthIndexInputProps.ticker;
    const market = relativeStrengthIndexInputProps.market;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const rsi = patternInput[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(undefined);
    const setErrMsg = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(true);
    const showReferenceLines = patternInput_2[0];
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(false);
    const showClose = patternInput_3[0];
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(AssetRSI_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/ta/rsi/${market}/${ticker}`, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(AssetRSI_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 1) {
                    setErrMsg("Kunne ikke laste teknisk analyse for aksje. Vennligst prøv igjen senere.");
                    return Promise.resolve();
                }
                else {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    return taHolder(ofArray([Alert_snackError(patternInput_1[0], () => {
        setErrMsg(undefined);
    }), taGraphHolder(toList(delay(() => append(singleton(taTitle("Relative Strength Index (RSI)")), delay(() => {
        let rsi_1;
        return append(singleton(description(`RSI (14) utvikling over siste ${(rsi != null) ? ((rsi_1 = rsi, int32ToString(rsi_1.length))) : "90"} handelsdager for aksjen. Tradisjonelt vurderer man en RSI verdi over 70 som overkjøpt og verdi under 30 som oversolgt ifølge teknisk analyse. Utregningen er gjort med J. Welles Wilder's originale formell, ofte kalt "Wilder's Smoothing Method".`)), delay(() => {
            const matchValue_1 = rsi;
            if (matchValue_1 != null) {
                const x_2 = matchValue_1;
                return append(singleton(rsiChart(x_2, showReferenceLines, showClose)), delay(() => {
                    let elems;
                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 10 + "px ",
                    }], (elems = [Checkbox_checkbox("Vis referanselinjer", showReferenceLines, patternInput_2[1]), Checkbox_checkbox("Vis sluttkurs", showClose, patternInput_3[1])], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                        let elems_4, elems_2, elems_3, l_1, l_2, l_3;
                        const latest = tryLast(x_2);
                        return append(singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                        }], (elems_2 = toList(delay(() => {
                            let elems_1;
                            if (latest != null) {
                                const l = latest;
                                return append(singleton(createElement("span", createObj(ofArray([["style", {}], (elems_1 = [createElement("span", {
                                    children: ["RSI: "],
                                }), createElement("span", {
                                    style: {
                                        fontWeight: "bold",
                                    },
                                    children: format('{0:' + "0.00" + '}', l.RSI),
                                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => singleton(createElement("span", {
                                    style: {
                                        color: "var(--text-dim)",
                                        fontSize: Dimensions_TextSmall,
                                    },
                                    children: `Per ${Time_utcDateToLocalDate(l.Date)}`,
                                }))));
                            }
                            else {
                                return singleton(createElement("span", {
                                    children: ["RSI: N/A"],
                                }));
                            }
                        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {}], (elems_3 = [createElement("span", {
                            children: ["Vurdering: "],
                        }), createElement("span", {
                            style: {
                                borderRadius: 5,
                                padding: 5,
                                backgroundColor: (latest != null) ? ((l_1 = latest, (l_1.RSI >= 70) ? "var(--sell)" : ((l_1.RSI <= 30) ? "var(--buy)" : StockRating__ToColorCode(new StockRating(2, []))))) : "var(--bg-main)",
                                color: (latest != null) ? ((l_2 = latest, ((l_2.RSI > 30) && (l_2.RSI < 70)) ? StockRating__ToTextColorCode(new StockRating(2, [])) : "#fff")) : "var(--text-main)",
                            },
                            children: (latest != null) ? ((l_3 = latest, (l_3.RSI >= 70) ? "Overkjøpt" : ((l_3.RSI <= 30) ? "Oversolgt" : "Nøytral"))) : "N/A",
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                            let l_4;
                            return singleton(createElement("span", {
                                children: (latest != null) ? ((l_4 = latest, (l_4.RSI >= 70) ? "RSI over 70 indikerer at aksjen er overkjøpt" : ((l_4.RSI <= 30) ? "RSI under 30 indikerer at aksjen er oversolgt." : ((l_4.RSI > 60) ? (`RSI på ${Format_quoteToString(l_4.RSI)} indikerer at aksjen nærmer seg overkjøpt.`) : ((l_4.RSI < 40) ? (`RSI på ${Format_quoteToString(l_4.RSI)} indikerer at aksjen nærmer seg oversolgt.`) : (`RSI på ${Format_quoteToString(l_4.RSI)} gir ingen klar indikasjon på om aksjen er overkjøpt eller oversolgt.`)))))) : "Ikke nok data",
                            }));
                        }));
                    }));
                }));
            }
            else {
                return singleton(LoadingIndicator_skeleton(ofArray([["width", 100 + "%"], ["minHeight", 250]])));
            }
        }));
    })))))]));
}

export function drawAppInfo(txt) {
    let elems_3, elems_2, elems, elems_1;
    return createElement("div", createObj(ofArray([["className", "default-gap"], ["style", createObj(ofArray([["display", "flex"], ["flexDirection", "column"], ["justifyContent", "space-around"], ["alignItems", "center"], ["backgroundColor", "#FFFFFF"], ["borderRadius", 5], DefaultBorder, ["padding", 1 + "vw"], ["textAlign", "left"]]))], (elems_3 = [createElement("span", {
        children: [txt],
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 20 + "px ",
    }], (elems_2 = [createElement("a", createObj(ofArray([["style", {
        lineHeight: 0 + "px",
    }], ["href", "https://apps.apple.com/app/aksje-io/id6448765436"], ["aria-label", "Last ned aksje.io fra Apple App Store"], (elems = [createElement("img", {
        src: "/images/app_store_download.svg",
        target: "_blank",
        alt: "Lenke til aksje.io på Apple App Store",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("a", createObj(ofArray([["style", {
        lineHeight: 0 + "px",
    }], ["href", "https://play.google.com/store/apps/details?id=io.aksje.app&pli=1"], ["target", "_blank"], (elems_1 = [createElement("img", {
        style: {
            height: 50,
        },
        src: "https://play.google.com/intl/en_us/badges/static/images/badges/no_badge_web_generic.png",
        alt: "Last ned fra Google Play Store",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
}

export class MAData extends Record {
    constructor(Date$, Kurs, SMA20, SMA50, SMA100, SMA200, EMA12, EMA26) {
        super();
        this.Date = Date$;
        this.Kurs = Kurs;
        this.SMA20 = SMA20;
        this.SMA50 = SMA50;
        this.SMA100 = SMA100;
        this.SMA200 = SMA200;
        this.EMA12 = EMA12;
        this.EMA26 = EMA26;
    }
}

export function MAData_$reflection() {
    return record_type("AssetTA.MAData", [], MAData, () => [["Date", string_type], ["Kurs", float64_type], ["SMA20", option_type(float64_type)], ["SMA50", option_type(float64_type)], ["SMA100", option_type(float64_type)], ["SMA200", option_type(float64_type)], ["EMA12", option_type(float64_type)], ["EMA26", option_type(float64_type)]]);
}

export function MovingAverages(movingAveragesInputProps) {
    const ticker = movingAveragesInputProps.ticker;
    const market = movingAveragesInputProps.market;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const sma20 = patternInput[0];
    const setSma20 = patternInput[1];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(undefined);
    const sma50 = patternInput_1[0];
    const setSma50 = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(undefined);
    const sma100 = patternInput_2[0];
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(undefined);
    const sma200 = patternInput_3[0];
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(undefined);
    const setEma12 = patternInput_4[1];
    const ema12 = patternInput_4[0];
    const patternInput_5 = useFeliz_React__React_useState_Static_1505(undefined);
    const ema26 = patternInput_5[0];
    const patternInput_6 = useFeliz_React__React_useState_Static_1505(undefined);
    const setErrMsg = patternInput_6[1];
    const patternInput_7 = useFeliz_React__React_useState_Static_1505(false);
    const showClose = patternInput_7[0];
    const patternInput_8 = useFeliz_React__React_useState_Static_1505({
        ema12: false,
        ema26: false,
        sma100: false,
        sma20: true,
        sma200: false,
        sma50: true,
    });
    const setSelected = patternInput_8[1];
    const selectedMA = patternInput_8[0];
    const getSMA = (frame, assign) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(AssetMA_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/ta/sma/${market}/${ticker}?frame=${frame}`, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(AssetMA_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 1) {
                    setErrMsg("Kunne ikke laste simple moving average for aksje. Vennligst prøv igjen senere.");
                    return Promise.resolve();
                }
                else {
                    assign(ofArray_1(map_1((y) => [y.Date, y], res.fields[0]), {
                        Compare: comparePrimitives,
                    }));
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    };
    const getEMA = (frame_1, assign_1) => {
        const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder_3, data_5, caseStrategy_10, extra_10;
            return ((decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(AssetMA_$reflection()), undefined, undefined), (data_5 = undefined, (caseStrategy_10 = undefined, (extra_10 = undefined, (() => {
                let properties_6;
                try {
                    const properties_3_1 = Helper_withProperties(empty_1(), (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty_1()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_10, extra_10)(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/ta/ema/${market}/${ticker}?frame=${frame_1}`, properties_3_1).then((_arg_3) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(AssetMA_$reflection()), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_4) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    return pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                }
                catch (exn_1) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
            })()))))).then((_arg_5) => {
                const res_1 = _arg_5;
                if (res_1.tag === 1) {
                    setErrMsg("Kunne ikke laste exponential moving average for aksje. Vennligst prøv igjen senere.");
                    return Promise.resolve();
                }
                else {
                    assign_1(ofArray_1(map_1((y_2) => [y_2.Date, y_2], res_1.fields[0]), {
                        Compare: comparePrimitives,
                    }));
                    return Promise.resolve();
                }
            });
        }));
        pr_3.then();
    };
    useReact_useEffectOnce_3A5B6456(() => {
        getSMA(20, setSma20);
        getSMA(50, setSma50);
        getEMA(12, setEma12);
    });
    const selectButton = (title, bg, isSelected, onChange) => {
        let elems;
        return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => append(isSelected ? singleton(["backgroundColor", bg]) : empty(), delay(() => append(singleton(["border", (((1 + "px ") + "solid") + " ") + bg]), delay(() => append(singleton(["cursor", "pointer"]), delay(() => append(singleton(["fontSize", Dimensions_TextSmall]), delay(() => append(isSelected ? singleton(["color", "#FFFFFF"]) : singleton(["color", "var(--bg-dark)"]), delay(() => append(singleton(["padding", ((3 + "px ") + 5) + "px"]), delay(() => append(singleton(["borderRadius", 5]), delay(() => append(singleton(["userSelect", "none"]), delay(() => singleton(["whiteSpace", "nowrap"]))))))))))))))))))))))))))], ["onClick", (_arg_9) => {
            onChange();
        }], (elems = [createElement("span", {
            children: [title],
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
    };
    return taHolder(ofArray([Alert_snackError(patternInput_6[0], () => {
        setErrMsg(undefined);
    }), taGraphHolder(toList(delay(() => append(singleton(taTitle("Moving Averages (SMA, EMA)")), delay(() => append(singleton(description("Simple Moving Average (SMA) og Exponential Moving Average (EMA) for aksjen de siste 90 handelsdager. Legg til og fjern Moving Average kategorier og perioder fra valgknappene under grafen.")), delay(() => {
        let props_15, props_12, x_8;
        if ((sma50 != null) ? true : (sma200 != null)) {
            const data_9 = map_1((tupledArg) => {
                const date = tupledArg[0];
                return new MAData(date, tupledArg[1].Quote, (sma20 != null) ? map((s) => s.Value, FSharpMap__TryFind(sma20, date)) : undefined, (sma50 != null) ? map((s_1) => s_1.Value, FSharpMap__TryFind(sma50, date)) : undefined, (sma100 != null) ? map((s_2) => s_2.Value, FSharpMap__TryFind(sma100, date)) : undefined, (sma200 != null) ? map((s_3) => s_3.Value, FSharpMap__TryFind(sma200, date)) : undefined, (ema12 != null) ? map((s_4) => s_4.Value, FSharpMap__TryFind(ema12, date)) : undefined, (ema26 != null) ? map((s_5) => s_5.Value, FSharpMap__TryFind(ema26, date)) : undefined);
            }, toArray((sma20 != null) ? value_47(sma20) : ((sma50 != null) ? value_47(sma50) : ((sma100 != null) ? value_47(sma100) : ((sma200 != null) ? value_47(sma200) : ((ema12 != null) ? value_47(ema12) : ((ema26 != null) ? value_47(ema26) : empty_2({
                Compare: comparePrimitives,
            }))))))));
            return (data_9.length > 0) ? append(singleton((props_15 = [["minWidth", 250], ["minHeight", 210], ["children", singleton_1((props_12 = [["style", ofArray([["width", 450], ["height", 300]])], ["data", data_9], (x_8 = [0, 0, 0, 0], ["margin", {
                bottom: x_8[2],
                left: x_8[3],
                right: x_8[1],
                top: x_8[0],
            }]), ["children", toList(delay(() => append(singleton(Interop_reactApi_1.createElement(XAxis, {
                dataKey: "Date",
                tickFormatter: (tick) => (`${Time_utcDateToLocalDayAndMonth(tick)}`),
            })), delay(() => {
                let props_3;
                return append(singleton((props_3 = [["orientation", "right"], ["tickFormatter", (tick_1) => (`${~~tick_1}`)], ["domain", ["auto", "auto"]]], Interop_reactApi_1.createElement(YAxis, createObj(props_3)))), delay(() => append(singleton(Interop_reactApi_1.createElement(Tooltip, {
                    formatter: (v) => ((_arg_7) => ((_arg_8) => format('{0:' + "0.00" + '}', v))),
                })), delay(() => append(selectedMA.sma20 ? singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "SMA20",
                    stroke: "#882d17",
                    strokeWidth: 3,
                    dot: false,
                })) : empty(), delay(() => append(selectedMA.sma50 ? singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "SMA50",
                    stroke: "#4169E1",
                    strokeWidth: 3,
                    dot: false,
                })) : empty(), delay(() => append(selectedMA.sma100 ? singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "SMA100",
                    stroke: "#ff4500",
                    strokeWidth: 3,
                    dot: false,
                })) : empty(), delay(() => append(selectedMA.sma200 ? singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "SMA200",
                    stroke: "#8b008b",
                    strokeWidth: 3,
                    dot: false,
                })) : empty(), delay(() => append(selectedMA.ema12 ? singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "EMA12",
                    stroke: "#008080",
                    strokeWidth: 3,
                    dot: false,
                })) : empty(), delay(() => append(selectedMA.ema26 ? singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "EMA26",
                    stroke: "#ff8c00",
                    strokeWidth: 3,
                    dot: false,
                })) : empty(), delay(() => (showClose ? singleton(Interop_reactApi_1.createElement(Line, {
                    dataKey: "Kurs",
                    stroke: "var(--text-dim)",
                    strokeWidth: 3,
                    dot: false,
                })) : empty())))))))))))))))));
            }))))]], Interop_reactApi_1.createElement(LineChart, createObj(props_12))))]], Interop_reactApi_1.createElement(ResponsiveContainer, createObj(props_15)))), delay(() => {
                let elems_1;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: 10 + "px ",
                }], (elems_1 = [selectButton("SMA (20)", "#882d17", selectedMA.sma20, () => {
                    setSelected({
                        ema12: selectedMA.ema12,
                        ema26: selectedMA.ema26,
                        sma100: selectedMA.sma100,
                        sma20: !selectedMA.sma20,
                        sma200: selectedMA.sma200,
                        sma50: selectedMA.sma50,
                    });
                    if (sma20 == null) {
                        getSMA(20, setSma20);
                    }
                }), selectButton("SMA (50)", "#4169E1", selectedMA.sma50, () => {
                    setSelected({
                        ema12: selectedMA.ema12,
                        ema26: selectedMA.ema26,
                        sma100: selectedMA.sma100,
                        sma20: selectedMA.sma20,
                        sma200: selectedMA.sma200,
                        sma50: !selectedMA.sma50,
                    });
                    if (sma50 == null) {
                        getSMA(50, setSma50);
                    }
                }), selectButton("SMA (100)", "#ff4500", selectedMA.sma100, () => {
                    setSelected({
                        ema12: selectedMA.ema12,
                        ema26: selectedMA.ema26,
                        sma100: !selectedMA.sma100,
                        sma20: selectedMA.sma20,
                        sma200: selectedMA.sma200,
                        sma50: selectedMA.sma50,
                    });
                    if (sma100 == null) {
                        getSMA(100, patternInput_2[1]);
                    }
                }), selectButton("SMA (200)", "#8b008b", selectedMA.sma200, () => {
                    setSelected({
                        ema12: selectedMA.ema12,
                        ema26: selectedMA.ema26,
                        sma100: selectedMA.sma100,
                        sma20: selectedMA.sma20,
                        sma200: !selectedMA.sma200,
                        sma50: selectedMA.sma50,
                    });
                    if (sma200 == null) {
                        getSMA(200, patternInput_3[1]);
                    }
                }), selectButton("EMA (12)", "#008080", selectedMA.ema12, () => {
                    setSelected({
                        ema12: !selectedMA.ema12,
                        ema26: selectedMA.ema26,
                        sma100: selectedMA.sma100,
                        sma20: selectedMA.sma20,
                        sma200: selectedMA.sma200,
                        sma50: selectedMA.sma50,
                    });
                    if (ema12 == null) {
                        getEMA(12, setEma12);
                    }
                }), selectButton("EMA (26)", "#ff8c00", selectedMA.ema26, () => {
                    setSelected({
                        ema12: selectedMA.ema12,
                        ema26: !selectedMA.ema26,
                        sma100: selectedMA.sma100,
                        sma20: selectedMA.sma20,
                        sma200: selectedMA.sma200,
                        sma50: selectedMA.sma50,
                    });
                    if (ema26 == null) {
                        getEMA(26, patternInput_5[1]);
                    }
                }), Checkbox_checkbox("Vis sluttkurs", showClose, patternInput_7[1])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))));
            })) : empty();
        }
        else {
            return empty();
        }
    })))))))]));
}

export class MACDData extends Record {
    constructor(Date$, Signal, MACD, EMATwelve, EMATwentySix, Histogram, Close) {
        super();
        this.Date = Date$;
        this.Signal = Signal;
        this.MACD = MACD;
        this.EMATwelve = EMATwelve;
        this.EMATwentySix = EMATwentySix;
        this.Histogram = Histogram;
        this.Close = Close;
    }
}

export function MACDData_$reflection() {
    return record_type("AssetTA.MACDData", [], MACDData, () => [["Date", string_type], ["Signal", float64_type], ["MACD", float64_type], ["EMATwelve", float64_type], ["EMATwentySix", float64_type], ["Histogram", float64_type], ["Close", float64_type]]);
}

export class MACDBar extends Record {
    constructor(Date$, Signal, MACD, Histogram) {
        super();
        this.Date = Date$;
        this.Signal = Signal;
        this.MACD = MACD;
        this.Histogram = Histogram;
    }
}

export function MACDBar_$reflection() {
    return record_type("AssetTA.MACDBar", [], MACDBar, () => [["Date", string_type], ["Signal", float64_type], ["MACD", float64_type], ["Histogram", float64_type]]);
}

function MACD(mACDInputProps) {
    const ticker = mACDInputProps.ticker;
    const market = mACDInputProps.market;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(undefined);
    const setErrMsg = patternInput_1[1];
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(MACDData_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/ta/macd/${market}/${ticker}`, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(MACDData_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 1) {
                    setErrMsg("Kunne ikke laste MACD for aksje. Vennligst prøv igjen senere.");
                    return Promise.resolve();
                }
                else {
                    patternInput[1](sortBy((x_2) => x_2.Date, map_1((m) => (new MACDBar(m.Date, m.Signal, m.MACD, m.Histogram)), res.fields[0]), {
                        Compare: comparePrimitives,
                    }));
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    return taHolder(ofArray([Alert_snackError(patternInput_1[0], () => {
        setErrMsg(undefined);
    }), taGraphHolder(toList(delay(() => append(singleton(taTitle("Moving average convergence/divergence (MACD)")), delay(() => append(singleton(description("Grafen viser MACD verdier for aksjen de siste 90 handelsdager basert på 12 dagers EMA minus 26 dagers EMA og 9 dagers signal. MACD er en indikator som kan brukes for å forså momentum av kursutviklingen.")), delay(() => {
        let props_10, data_4, props_9, x_7, props_2, props_3, props_8;
        const matchValue_1 = patternInput[0];
        return (matchValue_1 != null) ? append(singleton((props_10 = [["minWidth", 250], ["minHeight", 210], ["children", singleton_1((data_4 = matchValue_1, (props_9 = [["width", 450], ["height", 300], ["data", data_4], (x_7 = [0, 0, 0, 0], ["margin", {
            bottom: x_7[2],
            left: x_7[3],
            right: x_7[1],
            top: x_7[0],
        }]), ["children", ofArray([Interop_reactApi_1.createElement(XAxis, {
            dataKey: "Date",
            tickFormatter: (tick) => (`${Time_utcDateToLocalDayAndMonth(tick)}`),
        }), (props_2 = [["yAxisId", "left"], ["tickFormatter", (tick_1) => (`${~~tick_1}`)], ["domain", ["auto", "auto"]], ["allowDecimals", true]], Interop_reactApi_1.createElement(YAxis, createObj(props_2))), (props_3 = [["yAxisId", "right"], ["orientation", "right"], ["tickFormatter", (tick_2) => (`${~~tick_2}`)], ["domain", ["auto", "auto"]], ["allowDecimals", true]], Interop_reactApi_1.createElement(YAxis, createObj(props_3))), Interop_reactApi_1.createElement(Tooltip, {
            formatter: (v) => ((_arg_4) => ((_arg_5) => format('{0:' + "0.00" + '}', v))),
        }), Interop_reactApi_1.createElement(Line, {
            dataKey: "MACD",
            stroke: "#008080",
            strokeWidth: 3,
            dot: false,
            yAxisId: "left",
        }), Interop_reactApi_1.createElement(Line, {
            dataKey: "Signal",
            stroke: "#ff8c00",
            strokeWidth: 3,
            dot: false,
            yAxisId: "left",
        }), (props_8 = [["dataKey", "Histogram"], ["fill", "var(--text-main)"], ["yAxisId", "right"], ["fillOpacity", 0.3], ["children", ofArray(mapIndexed((i, x_31) => {
            const props_7 = [["key", `m-${i}`], ["fill", (x_31.Histogram >= 0) ? "var(--buy)" : "var(--sell)"]];
            return Interop_reactApi_1.createElement(Cell, createObj(props_7));
        }, sortBy((x_29) => x_29.Date, data_4, {
            Compare: comparePrimitives,
        })))]], Interop_reactApi_1.createElement(Bar, createObj(props_8)))])]], Interop_reactApi_1.createElement(ComposedChart, createObj(props_9)))))]], Interop_reactApi_1.createElement(ResponsiveContainer, createObj(props_10)))), delay(() => {
            let elems_1, elems;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: 20 + "px ",
            }], (elems_1 = [createElement("span", {
                style: {
                    color: "#008080",
                    fontSize: Dimensions_TextSmall,
                },
                children: "- MACD",
            }), createElement("span", {
                style: {
                    color: "#ff8c00",
                    fontSize: Dimensions_TextSmall,
                },
                children: "- Signal (9)",
            }), createElement("div", createObj(ofArray([["style", {
                fontSize: Dimensions_TextSmall,
                display: "flex",
                alignItems: "center",
                gap: 5 + "px ",
            }], (elems = [createElement("div", {
                style: {
                    width: 15,
                    height: 15,
                    opacity: 0.3,
                    backgroundImage: `linear-gradient(90deg, ${"var(--buy)"} 50%,${"var(--sell)"} 50%)`,
                },
            }), createElement("span", {
                children: ["Histogram"],
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))));
        })) : singleton(LoadingIndicator_skeleton(ofArray([["width", 100 + "%"], ["minHeight", 220]])));
    })))))))]));
}

export function TechnicalAnalysis(technicalAnalysisInputProps) {
    let elems;
    const ticker = technicalAnalysisInputProps.ticker;
    const market = technicalAnalysisInputProps.market;
    return createElement("div", createObj(ofArray([["className", "default-gap"], ["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems = [createElement("div", {
        key: "rsi",
        children: createElement(RelativeStrengthIndex, {
            market: market,
            ticker: ticker,
        }),
    }), createElement(AssetBanner, null), createElement("div", {
        key: "ma",
        children: createElement(MovingAverages, {
            market: market,
            ticker: ticker,
        }),
    }), createElement("div", {
        key: "macd",
        children: createElement(MACD, {
            market: market,
            ticker: ticker,
        }),
    }), createElement(AssetBanner, null), drawAppInfo("Få push-varslinger ved endringer i RSI-verdi. Last ned aksje.io appen!")], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

